/* istanbul ignore file */
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader } from 'framework/ui/layout';

const SkillBasedQueueEntityHeader = () => {
  return <EntityHeader entityTitleSource="id" defaultAuthor={DEFAULT_ENTITY_AUTHOR} />;
};

export default SkillBasedQueueEntityHeader;
